(function () {
  function initFaq(root) {
    root.querySelectorAll('[data-siokiuu-faq-button]').forEach(function (button) {
      if (button.dataset.siokiuuReady === 'true') return;
      button.dataset.siokiuuReady = 'true';

      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
    });
  }

  function initReviews(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-siokiuu-review-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-siokiuu-review-dot]'));
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-siokiuu-review-arrow]'));
    var track = root.querySelector('[data-siokiuu-review-track]');

    if (track && cards.length) {
      arrows.forEach(function (arrow) {
        if (arrow.dataset.siokiuuReady === 'true') return;
        arrow.dataset.siokiuuReady = 'true';

        arrow.addEventListener('click', function () {
          var firstCard = cards[0];
          var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0) || 0;
          var distance = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth;
          var direction = Number(arrow.dataset.direction || 1);
          track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        });
      });
      return;
    }

    if (!cards.length || !dots.length) return;

    function showReview(index) {
      var nextIndex = (index + cards.length) % cards.length;
      cards.forEach(function (card, cardIndex) {
        card.classList.toggle('is-active', cardIndex === nextIndex);
      });
      dots.forEach(function (item, dotIndex) {
        item.classList.toggle('is-active', dotIndex === nextIndex);
      });
    }

    dots.forEach(function (dot, index) {
      if (dot.dataset.siokiuuReady === 'true') return;
      dot.dataset.siokiuuReady = 'true';

      dot.addEventListener('click', function () {
        showReview(index);
      });
    });

    arrows.forEach(function (arrow) {
      if (arrow.dataset.siokiuuReady === 'true') return;
      arrow.dataset.siokiuuReady = 'true';

      arrow.addEventListener('click', function () {
        var activeIndex = cards.findIndex(function (card) {
          return card.classList.contains('is-active');
        });
        var direction = Number(arrow.dataset.direction || 1);
        showReview(activeIndex + direction);
      });
    });
  }

  function initHeader() {
    document.querySelectorAll('[data-siokiuu-home-header]').forEach(function (header) {
      var button = header.querySelector('[data-siokiuu-menu-toggle]');
      var menu = header.querySelector('#siokiuu-home-mobile-menu');
      if (!button || !menu || button.dataset.siokiuuReady === 'true') return;

      button.dataset.siokiuuReady = 'true';
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        menu.hidden = expanded;
        header.classList.toggle('is-menu-open', !expanded);
      });
    });
  }

  function initCartCountBadges() {
    document.querySelectorAll('.siokiuu-home-header__cart-count[data-cart-count]').forEach(function (badge) {
      function syncBadge() {
        var count = parseInt((badge.textContent || '').replace(/\D/g, ''), 10) || 0;
        if (badge.textContent !== String(count)) {
          badge.textContent = String(count);
        }
        badge.classList.toggle('is-empty', count < 1);
      }

      syncBadge();

      if (badge.dataset.siokiuuBadgeReady === 'true') return;
      badge.dataset.siokiuuBadgeReady = 'true';

      var observer = new MutationObserver(syncBadge);
      observer.observe(badge, { childList: true, characterData: true, subtree: true });
    });
  }

  function initSearch(root) {
    root.querySelectorAll('[data-siokiuu-search]').forEach(function (form) {
      if (form.dataset.siokiuuReady === 'true') return;
      form.dataset.siokiuuReady = 'true';

      var input = form.querySelector('[data-siokiuu-search-input]');
      var results = form.querySelector('[data-siokiuu-search-results]');
      var predictiveUrl = form.dataset.predictiveUrl;
      var debounceTimer = null;
      var activeController = null;
      if (!input || !results || !predictiveUrl) return;

      function closeResults() {
        results.hidden = true;
        results.innerHTML = '';
      }

      function renderEmpty(message) {
        results.innerHTML = '<span>' + message + '</span>';
        results.hidden = false;
      }

      function renderProducts(products, query) {
        if (!products.length) {
          renderEmpty('No products found for "' + query + '".');
          return;
        }

        results.innerHTML = products.slice(0, 5).map(function (product) {
          return '<a href="' + product.url + '">' + escapeHtml(product.title) + '</a>';
        }).join('');
        results.hidden = false;
      }

      function escapeHtml(value) {
        var span = document.createElement('span');
        span.textContent = value;
        return span.innerHTML;
      }

      function openSearch() {
        form.classList.add('is-search-open');
      }

      function closeSearch() {
        closeResults();
        form.classList.remove('is-search-open');
      }

      form.addEventListener('click', function (event) {
        if (!form.classList.contains('is-search-open')) {
          event.preventDefault();
          openSearch();
          window.setTimeout(function () {
            input.focus();
          }, 0);
        }
      });

      input.addEventListener('focus', openSearch);

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeSearch();
          input.blur();
        }
      });

      input.addEventListener('input', function () {
        var query = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (query.length < 2) {
          closeResults();
          return;
        }

        debounceTimer = window.setTimeout(function () {
          if (activeController) activeController.abort();
          activeController = new AbortController();

          var requestQuery = /^\d+$/.test(query) ? query + '*' : query;
          var url = predictiveUrl + '.json?q=' + encodeURIComponent(requestQuery) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
          fetch(url, { signal: activeController.signal })
            .then(function (response) {
              if (!response.ok) throw new Error('Search unavailable');
              return response.json();
            })
            .then(function (data) {
              var products = [];
              if (data.resources && data.resources.results && data.resources.results.products) {
                products = data.resources.results.products.map(function (product) {
                  return {
                    title: product.title,
                    url: product.url
                  };
                });
              }

              products = products.filter(function (product, index, list) {
                return product.title && product.url && list.findIndex(function (item) { return item.url === product.url; }) === index;
              });

              renderProducts(products, query);
            })
            .catch(function (error) {
              if (error.name === 'AbortError') return;
              renderEmpty('Press Enter to search.');
            });
        }, 180);
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) closeSearch();
      });
    });
  }

  function initBackToTop() {
    var button = document.querySelector('[data-siokiuu-back-to-top]');
    if (!button || button.dataset.siokiuuReady === 'true') return;

    button.dataset.siokiuuReady = 'true';

    function updateBackToTop() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = scrollHeight > 0 ? Math.min(scrollTop / scrollHeight, 1) : 0;

      button.style.setProperty('--siokiuu-back-progress', Math.round(progress * 360) + 'deg');
      button.classList.toggle('is-visible', scrollTop > 420);
    }

    button.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });

    updateBackToTop();
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    window.addEventListener('resize', updateBackToTop);
  }

  function initSiokiuuHome() {
    initHeader();
    initCartCountBadges();
    initSearch(document);
    initBackToTop();
    document.querySelectorAll('[data-siokiuu-home-v3]').forEach(function (root) {
      initFaq(root);
      initReviews(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiokiuuHome);
  } else {
    initSiokiuuHome();
  }

  document.addEventListener('shopify:section:load', initSiokiuuHome);
})();
